/* eslint-disable max-len */
/* eslint-disable react/jsx-no-comment-textnodes */
import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { MdCheckCircleOutline, MdHighlightOff, MdInfo } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Tooltip, Whisper } from 'rsuite';
import { WhisperTrigger } from 'rsuite/lib/Whisper';
import { InfoTable } from '../../../../../../../components';
import { RowData, toggleModal } from '../../../../../../../reducers/OtimizacaoPrecos/optimizationPricesList';
import { setOptimizationSummaryPriceList } from '../../../../../../../reducers/gerenciadorPrecos/optimizationPriceEdited';
import { formatNumbersToPtBr } from '../../../../../../../utils/FormatNumbers';
import { useGridTableActions } from '../../../../hooks/useGridTableActions';
import styles from './GridTable.module.scss';
import { CellWrapper } from './components/CellWrapper/CellWrapper';
import { DropdownEventKey, TableOptions } from './components/TableOptions';

const { Column, HeaderCell, Cell } = InfoTable;

const DATA_KEY = 'optimizationgrid';

const lengthMenu = [
  {
    value: 5,
    label: 5,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
];

export const PeriodType = {
  weekly: 'Semanal',
  monthly: 'Mensal',
};

export const GridTable = () => {
  const refs = useRef<{ [id: string]: WhisperTrigger }>({});
  const history = useHistory();
  const [tableKey, setTableKey] = useState(0);

  const dispatch = useDispatch();
  const { tableHandlers, tableState } = useGridTableActions();

  const paginationData = {
    total: tableState.pagination.totalElements,
    activePage: tableState.pagination.number + 1,
    displayLength: tableState.pagination.size,
    lengthMenu,
    onChangePage: tableHandlers.handleChangePage,
    onChangeLength: tableHandlers.handleChangeSize,
  };
  function handleSelectMenu(eventKey: string, id: string) {
    const triggerRef = refs.current[id];

    switch (eventKey) {
      case DropdownEventKey['delete-optimization']:
        dispatch(toggleModal({ name: 'delete', id: id.toString() }));
        break;
      case DropdownEventKey['edit-optimization']:
        history.push(`/ipa/ia/otimizacao-de-precos/${id}`);
        break;
      case DropdownEventKey['result-optimization']:
        history.push(`/ipa/ia/otimizacao-de-precos/resultado/${id}`);
        break;
      case DropdownEventKey['optimization-summary']:
        dispatch(setOptimizationSummaryPriceList({ id }));
        break;
      default:
        break;
    }

    // @ts-ignore
    triggerRef?.hide();
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTableKey(prevKey => prevKey + 1);
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main className={styles.container}>
      <InfoTable
        key={tableKey}
        data={tableState.data}
        dataKey={DATA_KEY}
        className={styles.table}
        loading={tableState.isLoadingSearchOptimizations}
        sortColumn={tableState.sortColumn || 'editedAt'}
        sortType={tableState.orderBy || 'desc'}
        minHeight={50}
        headerHeight={34}
        rowHeight={64}
        onSortColumn={tableHandlers.handleSetSortColumn}
        pagination={paginationData}
        rowClassName={(rowData: unknown) => ((rowData as RowData)?.status === 'inativa' ? styles.expiredRow : '')}
      >
        {/* @ts-ignore */}
        <Column width={40}>
          <HeaderCell />
          <Cell>
            {(rowData: RowData) => {
              return (
                <CellWrapper>
                  {rowData.status === 'ativa' ? (
                    <MdCheckCircleOutline color="#378EF0" style={{ height: 16, width: 16 }} />
                  ) : (
                    <MdHighlightOff color="#959595" style={{ height: 16, width: 16 }} />
                  )}
                </CellWrapper>
              );
            }}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column sortable flexGrow={1} minWidth={100}>
          <HeaderCell>Categoria</HeaderCell>
          <Cell dataKey="optimization.categoriesWithoutIds">
            {(rowData: RowData) => {
              return (
                <CellWrapper className={styles['main-content']}>
                  <Whisper trigger="hover" placement="right" speaker={<Tooltip>{rowData.categories.split(',').join(', ')}</Tooltip>}>
                    <div className={styles.highlight}>{rowData.categories.split(',').join(', ')}</div>
                  </Whisper>
                  {rowData?.totalProducts > 0 ? (
                    <div className={styles['sub-content-category']}>
                      {rowData.totalProducts} {rowData.totalProducts > 1 ? 'produtos' : 'produto'}
                    </div>
                  ) : null}
                </CellWrapper>
              );
            }}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column flexGrow={1} minWidth={100}>
          <HeaderCell>Loja</HeaderCell>
          <Cell dataKey="optimization.stores.store_id">
            {(rowData: RowData) => {
              const storesLength = rowData.stores?.length || 0;

              const storesIds =
                rowData.stores
                  ?.slice(0, 5)
                  .map(store => store.storeId)
                  .join(', ')
                  .concat(storesLength > 5 ? ' ...' : '') || '';

              const storesName =
                rowData.stores
                  ?.slice(0, 1)
                  .map(store => store.storeName)
                  .join(', ')
                  .concat(storesLength > 1 ? ' ...' : '') || '';

              const storesNameTooltip = rowData.stores?.map(store => store.storeName).join(', ') || '';
              const storesIdsTooltip = rowData.stores?.map(store => store.storeId).join(', ') || '';

              return (
                <CellWrapper className={styles['main-content']}>
                  <Whisper trigger="hover" placement="right" speaker={<Tooltip>{storesIdsTooltip}</Tooltip>}>
                    <span className={styles.highlight}>{storesIds}</span>
                  </Whisper>
                  <Whisper trigger="hover" placement="right" speaker={<Tooltip>{storesNameTooltip}</Tooltip>}>
                    <span className={styles['sub-content-store']}>{storesName}</span>
                  </Whisper>
                </CellWrapper>
              );
            }}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column sortable width={180}>
          <HeaderCell>Criação</HeaderCell>
          <Cell dataKey="createdAt">
            {(rowData: RowData) => (
              <CellWrapper className={styles['main-content']}>
                {rowData.createdAt ? <span>{format(new Date(`${rowData.createdAt}T12:00:00`), 'dd/MM/yyyy')}</span> : '--'}
                <span className={styles.responsible}>{rowData.responsible || '--'}</span>
              </CellWrapper>
            )}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column sortable width={180}>
          <HeaderCell>Última edição</HeaderCell>
          <Cell dataKey="editedAt">
            {(rowData: RowData) => (
              <CellWrapper className={styles['main-content']}>
                {rowData.editedAt ? <span>{format(new Date(`${rowData.editedAt}T12:00:00`), 'dd/MM/yyyy')}</span> : '--'}
                <span className={styles.responsible}>{rowData.editedBy || '--'}</span>
              </CellWrapper>
            )}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column sortable width={224}>
          <HeaderCell>
            <div className={styles['column-header']}>
              <span>Projeção de resultado</span>
              <Whisper
                trigger="hover"
                placement="bottom"
                speaker={<Tooltip>Projeção para 30 dias a partir do dia de otimização comparado com a categoria sem otimização</Tooltip>}
              >
                <MdInfo />
              </Whisper>
            </div>
          </HeaderCell>
          <Cell dataKey="resultsProjection">
            {(rowData: RowData) => {
              const { projectedProfit, projectedRevenue, projectedMargin, variationProfitPercentage } = rowData.resultsProjection || {};

              const projectedProfitFormatted = formatNumbersToPtBr(projectedProfit || 0, 'currency', {
                showSuffix: false,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              const projectedRevenueFormatted = formatNumbersToPtBr(projectedRevenue || 0, 'currency', {
                showSuffix: false,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              const projectedMarginFormatted = formatNumbersToPtBr(projectedMargin || 0, 'percent', { maximumFractionDigits: 1 });
              const variationProfitPercentageFormatted = {
                value: variationProfitPercentage
                  ? `${variationProfitPercentage > 0 ? ' + ' : ' - '}${formatNumbersToPtBr(variationProfitPercentage || 0, 'percent', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : 'SEM VAR.',
                color:
                  variationProfitPercentage === null || variationProfitPercentage === 0
                    ? 'badge-gray'
                    : variationProfitPercentage > 0
                      ? 'badge-green'
                      : 'badge-red',
              };

              return (
                <CellWrapper className={styles['main-content']}>
                  {projectedProfit ? (
                    <>
                      <Whisper
                        trigger="hover"
                        placement="right"
                        speaker={
                          <Tooltip>
                            <div>
                              <p>{`Lucro projetado`}</p>
                            </div>
                          </Tooltip>
                        }
                      >
                        <div className={styles['result-projection']}>
                          <span className={styles.highlight}>{projectedProfitFormatted}</span>
                          <span className={styles[variationProfitPercentageFormatted.color]}>{variationProfitPercentageFormatted.value}</span>
                        </div>
                      </Whisper>

                      <div className={styles['result-projection']}>
                        <Whisper
                          trigger="hover"
                          placement="right"
                          speaker={
                            <Tooltip>
                              <div>
                                <p>{`Faturamento projetado`}</p>
                              </div>
                            </Tooltip>
                          }
                        >
                          <span className={styles['sub-content-projection']}>{projectedRevenueFormatted}</span>
                        </Whisper>

                        <Whisper
                          trigger="hover"
                          placement="right"
                          speaker={
                            <Tooltip>
                              <div>
                                <p>{`Margem projetada`}</p>
                              </div>
                            </Tooltip>
                          }
                        >
                          <span className={styles['badge-gray']}>{`M. ${projectedMarginFormatted}`}</span>
                        </Whisper>
                      </div>
                    </>
                  ) : (
                    '--'
                  )}
                </CellWrapper>
              );
            }}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column width={120}>
          <HeaderCell />
          <Cell>
            {(rowData: RowData) => {
              return (
                <div className={styles['wrapper-buttons']}>
                  <Button appearance="link" onClick={() => handleSelectMenu(DropdownEventKey['result-optimization'], rowData.optimizationId)}>
                    Acompanhar
                  </Button>
                  <Whisper
                    placement="bottomEnd"
                    trigger="click"
                    triggerRef={(whisperRef: WhisperTrigger) => (refs.current[rowData.optimizationId] = whisperRef)}
                    speaker={<TableOptions onSelect={eventKey => handleSelectMenu(eventKey, rowData.optimizationId)} rowData={rowData} />}
                  >
                    <Button appearance="link">Mais...</Button>
                  </Whisper>
                </div>
              );
            }}
          </Cell>
        </Column>
      </InfoTable>
    </main>
  );
};
